<script setup lang="ts">
import EstateListing from '~/components/estate/listing/EstateListing.vue'

const { t, locale } = useI18n()

const seoContent = computed(() => getWarehouseListingContent(locale.value))

const seoTitle = computed(
  () =>
    seoContent.value?.title ??
    t('pages.estateListing.header.titles.seoWarehouse')
)

useHead({
  title: () => seoTitle.value,
  meta: [
    {
      name: 'title',
      content: seoTitle,
    },
    {
      name: 'description',
      content: computed(
        () =>
          seoContent.value?.description ??
          t('pages.estateListing.header.descriptions.warehouse')
      ),
    },
  ],
})

useFancyHeader()

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/warehouses',
    sk: '/sklady-haly-a-pozemky',
  },
})
</script>

<template>
  <EstateListing estate-type="warehouse" />
</template>
